const TokenType = Object.freeze({
    ROOT: "ROOT",
    KEYWORD: "KEYWORD",
    DELIMITER: "DELIMITER",
    CHARACTER_LITERAL: "CHARACTER_LITERAL"
});

export { TokenType };